import { render, staticRenderFns } from "./OptimizacionProduccion.vue?vue&type=template&id=0cfe7df6&scoped=true&"
import script from "./OptimizacionProduccion.vue?vue&type=script&lang=js&"
export * from "./OptimizacionProduccion.vue?vue&type=script&lang=js&"
import style0 from "./OptimizacionProduccion.vue?vue&type=style&index=0&id=0cfe7df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe7df6",
  null
  
)

export default component.exports